import React from 'react';
import PropTypes from 'prop-types';

class WinterJumbo extends React.Component {
  render() {
    return <div
      style={{
        background: '#00BFF3',
        padding: '15px',
        textAlign: 'center'
      }}
    >

      <h1
        style={{
          marginBottom: '0'
        }}
      >
        {this.props.title}
      </h1>

      <p
        style={{
          marginBottom: '0'
        }}
      >
        {this.props.subtitle}
      </p>

    </div>;
  }
}

// Prop types are a feature for runtime validation of props during development.
WinterJumbo.propTypes = {
  title: PropTypes.string.isRequired,
};

export default WinterJumbo;


// WEBPACK FOOTER //
// ./src/components/WinterJumbo/index.js